import {Card, Image, useTheme} from '@primer/react-brand/esm'
import {clsx} from 'clsx'
import {memo} from 'react'

import type {Cta, ThemedVisual} from '../../../../Index.types'

import Styles from './CustomerStory.module.css'

export interface CustomerStoryProps {
  logo: ThemedVisual
  description: string
  cta: Cta
}

export const CustomerStory = memo(function CustomerStoryCard({
  logo,
  description,
  cta,
  className,
}: CustomerStoryProps & {className?: string}) {
  const {colorMode} = useTheme()

  return (
    <Card
      className={clsx(Styles['CustomerStory'], className)}
      href={cta.url}
      fullWidth
      ctaVariant="arrow"
      ctaText={cta.label}
      leadingVisual={
        logo.url.dark ? (
          <Image
            src={colorMode === 'dark' ? logo.url.dark : logo.url.light}
            alt={logo.alt}
            className={Styles['CustomerStory__logo']}
          />
        ) : (
          <span
            role="img"
            aria-label={logo.alt}
            className={clsx(Styles['CustomerStory__logo'], Styles['CustomerStory__logo--flatColour'])}
            style={{maskImage: `url("${logo.url.light}")`}}
          />
        )
      }
    >
      {/* TODO: There's no h2 heading for that section, maybe make a sr-only one in `CustomerStory`? */}
      <Card.Heading as="h3" size="6" weight="normal" letterSpacing="none" textWrap="wrap">
        {description}
      </Card.Heading>
    </Card>
  )
})
